module.exports = __webpack_public_path__ + "img/ICONO12.7f5e10b4.png";